module.exports = __webpack_public_path__ + "img/login-bg.de90e4cc.png";